// import logo from './logo.svg';
// import './App.css';
import KGLHome from './comp/KglHome';

function App() {
  return (
    <>
    <KGLHome/>
    </>
  );
}

export default App;
